import * as React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { navigate } from "gatsby"
import fancyTimeFormat from "../helper/fancyTime"

const VideoCard = props => {
  const duration = fancyTimeFormat(props.youtube.end - props.youtube.start)

  return (
    <div
      onClick={() => {
        navigate("/" + props.slug)
      }}
      className="flex flex-col cursor-pointer bg-white overflow-hidden
      outline outline-1 outline-darkcdfblue shadow-solid
      max-w-xs m-5 transition duration-300"
    >
      <div className="text-right">
        <GatsbyImage image={props.miniature.childImageSharp.gatsbyImageData} />
        <div className="relative h-0 bottom-5 right-0">
          <span
            className="bg-white text-right text-darkcdfblue
          px-1 bg-opacity-100 font-mono"
          >
            {duration}
          </span>
        </div>
      </div>
      <div className="px-3 pt-3 grow">
        <h3 className="mb-1 mt-0">{props.title}</h3>
        <p className="text-gray-400 text-sm mb-1 max-h-12 truncate font-mono">
          With&nbsp;
          {props.speaks.map((el, i, arr) => (
            <span key={i}>
              {el.speaker}
              {i !== arr.length - 1 ? ", " : ""}
            </span>
          ))}
        </p>
      </div>
    </div>
  )
}

export default VideoCard
